// Doctrine color grade — each archetype applies a subtle hue shift to the
// rendered scene so the player's chosen doctrine reads visually.
//
// Hue values are in radians (0..2π). The shift is small (±0.1) so the grade
// stays tasteful rather than neon.

import type { Archetype } from '../../ui/DoctrinePanel/index.js';

interface DoctrineGrade {
  readonly hue: number;
  readonly saturation: number;
}

const DOCTRINE_GRADE: Readonly<Record<Archetype, DoctrineGrade>> = {
  // Cool blue tint for arcane.
  arcane: { hue: -0.08, saturation: 0.12 },
  // Red/violet tint for chaos.
  chaos: { hue: 0.12, saturation: 0.18 },
  // Gold tint for faith.
  faith: { hue: 0.04, saturation: 0.15 },
  // Warm amber tint for industry.
  industry: { hue: 0.02, saturation: 0.1 },
  // Green tint for nature.
  nature: { hue: -0.12, saturation: 0.12 },
  // Pure neutral for science (no grade).
  science: { hue: 0, saturation: 0 },
};

const DEFAULT_GRADE: DoctrineGrade = { hue: 0, saturation: 0 };

export function getDoctrineColorGrade(doctrine: Archetype | null): DoctrineGrade {
  if (!doctrine) return DEFAULT_GRADE;
  return DOCTRINE_GRADE[doctrine] ?? DEFAULT_GRADE;
}
